<template>
    <div :id="id" class="receipt" :class="{ print: isPrint }">
        <table class="receipt-bill" width="100%">
            <caption style="background: #fff">
                <div class="title">{{ companyInfo.title }}·明细收据</div>
                <div class="info">
                    <div class="info-item">
                        <div class="left">房号: {{ info.houseNum }}</div>
                        <div class="right color">
                            日期：{{ info.invoiceTime | toDateSelf }}
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="left">
                            {{ showName }} :
                            {{
                                showName === '客户名称'
                                    ? info.cusName
                                    : info.comName
                            }}
                        </div>
                        <div class="right color">
                            编号：<span v-if="isView" style="color: black">{{
                                info.receiptNo
                            }}</span
                            ><input
                                v-else
                                style="width: 170px"
                                type="text"
                                v-model="info.receiptNo"
                                class="input-class"
                                :class="inputReadonlyClass"
                                :readonly="isView"
                                placeholder="请输入编号-最长17位"
                                required
                                maxlength="17"
                            />
                        </div>
                    </div>
                </div>
            </caption>
            <tr>
                <th width="5%">编号</th>
                <th width="10%">项目名称</th>
                <th width="20%">所属时间</th>
                <th width="10%">建筑面积</th>
                <th width="10%">单位</th>
                <th width="15%">数量</th>
                <th width="15%">合计（元）</th>
            </tr>
            <tr v-for="(item, index) in info.detailList" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                    <input
                        type="text"
                        v-model="item.title"
                        class="input-class input-detailList"
                        :readonly="isView"
                        :class="inputReadonlyClass"
                    />
                </td>
                <td>
                    <input
                        type="text"
                        v-model="item.belongTime"
                        class="input-class input-detailList"
                        :readonly="isView"
                        :class="inputReadonlyClass"
                    />
                </td>
                <!-- 建筑面积 -->
                <td @mouseover="showInput" @mouseleave="hiddenInput">
                    <input
                        v-if="isShowInput && !isView"
                        type="text"
                        v-model="item.buildArea"
                        class="input-class"
                        required
                        :class="inputReadonlyClass"
                    />
                    <span v-else>
                        {{ item.buildArea ? item.buildArea + '㎡' : '' }}
                    </span>
                </td>
                <td>
                    <input
                        type="text"
                        v-model="item.unit"
                        class="input-class input-detailList"
                        :readonly="isView"
                        :class="inputReadonlyClass"
                    />
                </td>
                <td>
                    <input
                        type="text"
                        v-model="item.num"
                        class="input-class input-detailList"
                        :readonly="isView"
                        :class="inputReadonlyClass"
                    />
                </td>
                <!-- 合计 -->
                <td @mouseover="showInput" @mouseleave="hiddenInput">
                    <input
                        v-if="isShowInput && !isView"
                        type="text"
                        v-model="item.amount"
                        class="input-class"
                        required
                        :class="inputReadonlyClass"
                        @change="addTotalAmount"
                    />
                    <span v-else>
                        {{ item.amount | currency }}
                    </span>
                </td>
            </tr>
            <tr>
                <td colspan="2">合计金额（小写）</td>
                <td colspan="4" class="text-left">
                    ￥{{ info.totalAmount | currency }}
                </td>
                <td></td>
            </tr>
            <tr>
                <td colspan="2">合计金额（大写）</td>
                <td colspan="4" class="text-left">
                    {{ totalAmountText }}
                </td>
                <td></td>
            </tr>
            <tr>
                <td colspan="3">
                    收款方式：
                    <span v-if="isPrint">{{ curPayType.text }}</span>
                    <RadioGroup v-else v-model="info.payMethod">
                        <Radio
                            v-for="item in payTypeList"
                            :key="item.id"
                            :label="item.id"
                            :disabled="isView"
                        >
                            {{ item.text }}
                        </Radio>
                    </RadioGroup>
                </td>
                <td
                    colspan="2"
                    class="color text-left"
                    @mouseover="showInput"
                    @mouseleave="hiddenInput"
                >
                    实收金额：<input
                        v-if="isShowInput && !isView"
                        type="text"
                        v-model="info.amount"
                        class="input-class"
                        placeholder="请输入金额"
                        required
                        :class="inputReadonlyClass"
                    />
                    <span v-else>{{ info.amount | currency }}</span>
                </td>
                <td class="text-left">
                    收款人：<span v-if="isView">{{ info.payee }}</span
                    ><input
                        v-else
                        type="text"
                        v-model="info.payee"
                        class="input-class"
                        placeholder="请输入名字"
                        :readonly="isView"
                        :class="inputReadonlyClass"
                    />
                </td>
                <td class="text-left">收款单位（盖章）</td>
            </tr>
            <tr>
                <td class="remark">备注</td>
                <td colspan="6" class="color text-left">
                    <span v-if="isView">{{ info.remark }}</span
                    ><input
                        v-else
                        style="width: 100%"
                        type="textarea"
                        v-model="info.remark"
                        class="input-class"
                        :placeholder="isView ? '' : '请输入备注'"
                        :readonly="isView"
                        :class="inputReadonlyClass"
                    />
                </td>
            </tr>
        </table>
        <div class="footer-class">
            <span> 公司地址: {{ companyInfo.addr }} </span>
            <span style="padding-left: 15px">
                联系电话：{{ companyInfo.tel }}
            </span>
        </div>
    </div>
</template>

<script>
import { upDigit, ymd, toDate } from '_u/helper'
import printCss from '!file-loader?name=[contenthash].css!extract-loader!css-loader!less-loader!./receipt-bill-print.less'
import { companyView } from '@/api/company'

// 票据表格
export default {
    props: {
        // 根元素id
        id: {
            type: String,
            default: 'receipt',
        },
        // 票据详细数据
        info: {
            type: Object,
            default: () => ({}),
        },
        // 客户名称
        showName: {
            type: String,
            default: '客户名称',
        },
        // 是否只查看
        viewOnly: {
            type: Boolean,
            default: false,
        },
        // 收款方式s
        payTypeList: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isShowInput: false, // 是否显示是否金额输入框
            isPrint: false, // 是否打印模式
            companyInfo: {
                title: '',
                addr: '',
                tel: '',
            },
        }
    },

    created() {
        this.getCompanyInfo()
    },

    computed: {
        inputReadonlyClass() {
            return this.isView ? 'input-class-readonly' : ''
        },
        // 合计金额(大写)
        totalAmountText() {
            return upDigit(this.info.totalAmount)
        },
        // 是否查看模式
        isView() {
            return this.isPrint || this.viewOnly
        },
        // 当前收款方式
        curPayType() {
            return (
                this.payTypeList.find((v) => v.id === this.info.payMethod) || {
                    text: '',
                }
            )
        },
        companyName() {
            return process.env.VUE_APP_COMPANY_NAME
        },
    },

    filters: {
        toDateSelf: (val) => {
            if (val) {
                let date = toDate(val)
                date = ymd(date)
                const arr = date.split('-')
                return `${arr[0]}年${arr[1]}月${arr[2]}日`
            } else {
                return ''
            }
        },
    },

    methods: {
        // 获取公司信息
        getCompanyInfo() {
            companyView(this.id).then((res) => {
                this.companyInfo = {
                    title: res.data.entity.title,
                    addr: res.data.entity.addr,
                    tel: res.data.entity.tel,
                }
            })
        },
        // 合计金额计算
        addTotalAmount() {
            let total = 0
            this.info.detailList.forEach((v) => {
                total += parseInt(v.amount)
            })
            this.info.totalAmount = total
        },
        showInput() {
            this.isShowInput = true
        },
        hiddenInput() {
            this.isShowInput = false
        },
        // 打印
        print() {
            return import('print-js').then((printjs) => {
                // 使用查看状态，否则input控件会干扰打印效果
                this.isPrint = true

                return this.$nextTick(() => {
                    printJS({
                        printable: this.id,
                        type: 'html',
                        css: printCss,
                        scanStyles: false, // 样式完全由printCss决定
                    })

                    // 还原查看状态
                    this.isPrint = false
                })
            })
        },
    },
}
</script>

<style lang="less" scoped>
.receipt {
    padding: 10px;
    border-color: #000;
    color: #000;
    width: 950px;

    &-bill {
        border: 1px solid black;
        border-collapse: collapse;
    }

    .title {
        font-size: 28px;
        font-weight: bolder;
    }
    .info {
        text-align: left;
        &-item {
            font-size: 18px;
            display: flex;
            line-height: 30px;
            .left {
                flex-grow: 1;
            }
            .right {
                width: 230px;
            }
        }
    }
    .color {
        color: red;
        font-weight: bolder;
    }
    tr {
        text-align: center;
        line-height: 40px;
        font-weight: bold;
        font-size: 16px;
    }
    td,
    th {
        border: 1px solid black;
        background-color: #fff;
    }
    .text-left {
        text-align: left;
        padding-left: 5px;
    }
    .footer-class {
        margin-top: 5px;
        font-size: 16px;
        line-height: 30px;
    }
    .input-class {
        width: 50%;
        height: 20px;
        outline: none;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        &:hover {
            border-bottom-color: #000;
        }
    }
    .input-detailList {
        width: 90%;
        text-align: center;
        font-weight: bold;
    }
    .input-class-readonly {
        &:hover {
            border-bottom-color: rgba(0, 0, 0, 0);
        }
    }
    .remark {
        font-weight: bold;
    }
}
</style>
